import { SampleContextProvider } from 'contexts/sampleContext';
import { ErrorBoundary } from 'error';
import "i18n.ts";
import { MainPage } from 'pages';
import { LoginPage } from 'pages/login';
import { ProductPage } from 'pages/productPage';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { hot } from 'react-hot-loader/root';
import { BrowserRouter, Route } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer'
import "./app.scss";
import { useState } from 'react';

export const prefix = "pb-"

const App = hot(() => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SampleContextProvider>
          <Route path="/" exact component={MainPage} />
          <Route path="/login" exact component={LoginPage} />
          <Route path="/product/:id?" component={ProductPage} />
        </SampleContextProvider>
      </BrowserRouter>
    </ErrorBoundary>
  )
})

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);
